import { Pipe, PipeTransform } from "@angular/core";

// simple pipe that adds a "+" to positive numbers
@Pipe({
	name: "add_number_prefix",
	standalone: false
})
export class AddNumberPrefixPipe implements PipeTransform {
	public transform(value: string | number): string {
		return +value > 0 ? "+" + value : "" + value;
	}
}
